import styled from "styled-components";

/*
* Селект меню и кнопка периода. На узком вьюпорте переносятся и растягиваются: шапка карточки
* там становится колонкой, и nowrap-строка распирала бы страницу.
* */
export const Toolbar = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
    min-width: 0;
`;

export const MenuSelectCell = styled.div`
    min-width: 180px;
    flex: 1 1 180px;
`;
